import { render, staticRenderFns } from "./SPScope.vue?vue&type=template&id=f057008c&"
import script from "./SPScope.vue?vue&type=script&lang=ts&"
export * from "./SPScope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports